<template>
  <i
    class="cm-toggle-icon"
    :class="{ 'cm-toggle-icon--up': isUp }"
  ></i>
</template>

<script>
export default {
  name: "CmToggleIcon",

  props: {
    isUp: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.cm-toggle-icon {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 7px solid $color_text;
  margin: 8px 3px 0;
  will-change: transform, top;
  transition: transform border 0.2s ease-in;
  &:hover,
  &:active {
    border-top-color: $color_black;
  }

  &--up {
    transform: rotate(180deg) translate(0 3px);
  }
}
</style>
